var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('CCard',[_c('CCardHeader',[_vm._v("Timesheet")]),_c('TimesheetListHandler',{attrs:{"dataSource":_vm.dataSource,"dispatchFetch":_vm.dispatchFetch,"itemsPerPageSelect":false,"disableTopFilters":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }